import { useState , useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from 'react-redux';
import { RootState } from '@/store';
import { cityActions } from '@/reducers/cityConfig'
import './index.scss';
import { Space,IndexBar, List} from 'antd-mobile';
import apis from '@/api'

const City = () => {
  const {
    cityData,locationCity
  } = useSelector((state: RootState) => state.cityConfig);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [hotCityList, setHotCityList] = useState([]);
  const [cityList, setCityList] = useState([]);
  //获取城市列表
  const getCityList = async () => {
    const params = {
      "storeId": "110411"
    }
    const res: any = await apis.getCityList(params);
    if (res) {
      
      if(res&&res.hotCityList){
        res.hotCityList.map((item:any)=>{
          item.city = item.city.split('市')
        })
        setHotCityList(res.hotCityList)
      }
      if(res&&res.groupCityList){
        setCityList(res.groupCityList)
      }
    }
    
  }
  const checkedCity = (item:any) =>{
    dispatch(cityActions.setCity({
      cityId:item.cityId,
      cityName:item.city||item.cityName
    }));

    navigate(-1)    
  }
  useEffect(() => {
    window.WeixinJSBridge && window.WeixinJSBridge.call('hideOptionMenu');
    document.getElementsByTagName("title")[0].innerText = '选择城市';
    getCityList();

  }, [])
  return (
  <div className="city-list" style={{ height: window.innerHeight }}>
      
      <IndexBar>
        <IndexBar.Panel className="now__location"
        index={`#`}
        title={`定位/最近访问`}
        key={`定位`}
        >
          <Space wrap>
            {
              locationCity.cityId!=cityData.cityId
              ?
              <div className="location__name" onClick={()=>{checkedCity(locationCity)}}>
                <img alt="" src={require('@/images/location_icon.png')}/>
                {locationCity.cityName}
              </div>
              :null
            }
            <div className="location__name" onClick={()=>{checkedCity(cityData)}}>
              {
                locationCity.cityId==cityData.cityId
                ?
                <img alt="" src={require('@/images/location_icon.png')}/>
                :null
              }
              {cityData.cityName}
            </div>
          </Space>
          
        </IndexBar.Panel>
        <IndexBar.Panel className="now__location"
        index={`热`}
        title={`热门城市`}
        key={`热门城市`}
        >
          <Space className="hot__city__list" wrap>
            {hotCityList.map(group => {
                const { city, cityId } = group
                return <div  className="location__name" onClick={()=>{checkedCity(group)}}>{city}</div>
              })
            }
          </Space>
        </IndexBar.Panel>
        {cityList.map((group:any) => {
          const initial:any = Object.keys(group)
          const items:any = group[initial]
          return (
              <IndexBar.Panel className="city__list__tit"
              index={initial[0]}
              title={initial[0]}
              key={initial[0]}
              >
              <List>
                  {items.map((item:any, index:Number) => (
                  <List.Item onClick={()=>{checkedCity(item)}}>{item.city}</List.Item> 
                  ))}
              </List>
              </IndexBar.Panel>
          )
        })}
      </IndexBar>
  </div>
  )
}

export default City;
